import react, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import { Puff } from "react-loading-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BillingRequests from "../BillingRequests";
import NavBar from "../../../../components/NavBar";

const BillingCheckoutFinish = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({
    description: "",
    billing_total_price: "",
    billing_vat_value: "",
    billing_vat_price: "",
    id_venues: "",
  });
  let params = useParams();
  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const handlerCopyIBAN = () => {
    navigator.clipboard.writeText("LT973250046019875745");
    toast.success("IBAN adicionado à área de transferência.", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  const requestBillingSubscritionFinishInfo = async () => {
    setIsLoading(true);
    document.title = "Billing Subscriptions Finish | Nightspot Dashboard";
    let info = await BillingRequests.getSubscritionFinishInfo(params);
    if (info) {
      if (info.status) {
        setData(info.data.info);
      } else {
        if (info.redirect == true) {
          navigate("/my/billing/manager/" + info.data.id_venues);
        }
      }
    }
    setIsLoading(false);
  };

  useEffect(async () => {
    requestBillingSubscritionFinishInfo();
  }, []);

  return (
    <>
      <div>
        <NavBar>
          <div className="row">
            <div className="col-sm-12 dashboard-content">
              {isLoading ? (
                <InsideLoading />
              ) : (
                <>
                  <div className="row">
                    <div className="col-8">
                      <h2 className="dashboard-h2">Pagamento</h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <nav>
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <Link to="/my/dashboard">
                              <i className="fa-solid fa-home"></i>
                            </Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to="/my/nightspots">Lista Nightspots</Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to={`/my/billing/manager/${data.id_venues}`}>
                              Gestão de subscrição
                            </Link>
                          </li>
                          <li className="breadcrumb-item active">
                            Detalhes de subscrição e pagamento
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-6">
                      <h5>Resumo</h5>
                      <div
                        className="p-3 h-100"
                        style={{
                          backgroundColor: " #0a1116",
                          borderRadius: "8px",
                        }}
                      >
                        <table className="table table-nightspot">
                          <thead>
                            <tr>
                              <th>Descrição</th>
                              <th className="text-end">Valor</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="py-4">1 x {data.description}</td>
                              <td className="py-4 text-end">
                                {data.billing_total_price}€
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td className="text-end">
                                Taxa IVA: {data.billing_vat_price}%
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td className="text-end">
                                Total: {data.billing_vat_value}€
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-6">
                      <h5>Métodos de pagamento</h5>
                      <div
                        className="p-3 h-100"
                        style={{
                          backgroundColor: " #0a1116",
                          borderRadius: "8px",
                        }}
                      >
                        <div className="accordion mt-3" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                <i className="fa-solid fa-arrow-right-arrow-left"></i>
                                &nbsp; Transferência Bancária
                              </button>
                            </h2>
                            <div
                              id="collapseOne"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <div style={{ fontSize: "0.9rem" }}>
                                  Faça a tranferência para o iban mencionado
                                  abaixo e de seguida envie o comprovativo para
                                  o seguinte email:{" "}
                                  <a href="mailto:info@nightspot.pt">
                                    info@nightspot.pt
                                  </a>
                                </div>
                                <label className="form-label">IBAN</label>
                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  value="LT973250046019875745"
                                  onClick={() => handlerCopyIBAN()}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </NavBar>
      </div>
    </>
  );
};

export default BillingCheckoutFinish;
